import { z } from "zod"

import { casNumberSchema } from "@/utils/validation/casNumberValidation"

export const competitorProductFormSchema = z
  .object({
    competitorProductId: z.string().optional(),
    productName: z.string().min(1, "Product name is required").max(255, "Product name must be 255 characters or less"),
    chemicalName: z.string().max(255, "Chemical name must be 255 characters or less").optional().or(z.literal("")),
    casNumbers: z
      .array(z.union([z.literal(""), z.undefined(), casNumberSchema]))
      .optional()
      .default([]),
    manufacturer: z.string().max(255, "Manufacturer name must be 255 characters or less").optional().or(z.literal("")),
    distributors: z.array(z.string()).optional().default([]),
    technicalFile: z.instanceof(File).optional().nullable(),
  })
  .superRefine((data, ctx) => {
    // Check for duplicate CAS numbers
    const validNumbers = data.casNumbers?.filter((n) => n && n.trim() !== "") || []
    const uniqueNumbers = new Set(validNumbers)

    if (validNumbers.length !== uniqueNumbers.size) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Duplicate CAS numbers are not allowed",
        path: ["casNumbers"],
      })
    }
  })

export type CompetitorProductFormValues = z.infer<typeof competitorProductFormSchema>
